export const lifespanOptions = [
  {
    id: 1,
    label: 'Aluminum, general',
    years: 75,
  },
  {
    id: 2,
    label: 'Aluminum, sheet façade/roof',
    years: 40,
  },
  {
    id: 3,
    label: 'Asbestos, general',
    years: 60,
  },
  {
    id: 4,
    label: 'Asbestos, gaskets',
    years: 75,
  },
  {
    id: 5,
    label: 'Brick, general',
    years: 100,
  },
  {
    id: 6,
    label: 'Brick, façade',
    years: 75,
  },
  {
    id: 7,
    label: 'Concrete, general',
    years: 100,
    yearsBefore: 500,
  },
  {
    id: 8,
    label: 'Concrete, pre-cast beams, columns and façade',
    years: 75,
    yearsBefore: 500,
  },
  {
    id: 9,
    label: 'Bitumen',
    years: 30,
  },
  {
    id: 10,
    label: 'Plasterboard, general',
    years: 50,
  },
  {
    id: 11,
    label: 'Plasterboard, ceiling tiles',
    years: 20,
  },
  {
    id: 12,
    label: 'Glass, general',
    years: 75,
    yearsBefore: 500,
  },
  {
    id: 13,
    label: 'Glass, glazing, general',
    years: 30,
  },
  {
    id: 14,
    label: 'Glass, glazing, toughened',
    years: 40,
  },
  {
    id: 15,
    label: 'Timber, general',
    years: 75,
    yearsBefore: 300,
  },
  {
    id: 16,
    label: 'Timber, treated hardwood (outdoor)',
    years: 50,
  },
  {
    id: 17,
    label: 'Timber, treated softwood (outdoor)',
    years: 30,
  },
  {
    id: 18,
    label: 'Timber, cement bound particle board (outdoor)',
    years: 25,
  },
  {
    id: 19,
    label: 'Timber, load bearing, general, CLT',
    years: 100,
    yearsBefore: 500,
  },
  {
    id: 20,
    label: 'Timber, load bearing, OSB, LVL, LSL',
    years: 75,
  },
  {
    id: 21,
    label: 'Timber, parquet',
    years: 40,
  },
  {
    id: 22,
    label: 'Timber, window/door (indoor)',
    years: 100,
    yearsBefore: 500,
  },
  {
    id: 23,
    label: 'Timber, for timber frame internal walls',
    years: 50,
  },
  {
    id: 24,
    label: 'Insulation, general',
    years: 75,
  },
  {
    id: 25,
    label: "Insulation, loose cellulose/wood fiber, sheep's wool",
    years: 30,
  },
  {
    id: 26,
    label: 'Ceramics, sanitary',
    years: 50,
    yearsBefore: 300,
  },
  {
    id: 27,
    label: 'Ceramics, Tiles and cladding chemical connection',
    years: 40,
    yearsBefore: 300,
  },
  {
    id: 28,
    label: 'Ceramics, Tiles and cladding mechanical connection',
    years: 75,
    yearsBefore: 300,
  },
  {
    id: 29,
    label: 'Copper general',
    years: 100,
  },
  {
    id: 30,
    label: 'Copper end pipe',
    years: 25,
  },
  {
    id: 31,
    label: 'Copper main pipe',
    years: 50,
  },
  {
    id: 32,
    label: 'Plastics, acrylic glass',
    years: 40,
  },
  {
    id: 33,
    label: 'Plastics, EPDM / POCB roofing',
    years: 40,
  },
  {
    id: 34,
    label: 'Plastics, EPDM waterproofing layer',
    years: 50,
  },
  {
    id: 35,
    label: 'Plastics, HPL board (indoor)',
    years: 75,
  },
  {
    id: 36,
    label: 'Plastics, HPL board (outdoor)',
    years: 25,
  },
  {
    id: 37,
    label: 'Plastics, window frames',
    years: 40,
  },
  {
    id: 38,
    label: 'Plastics, PE waterproofing layer',
    years: 50,
  },
  {
    id: 39,
    label: 'Plastics, polycarbonate panels',
    years: 75,
  },
  {
    id: 40,
    label: 'Plastics, PVC roofing',
    years: 30,
  },
  {
    id: 41,
    label: 'Plastics, PVC / PE end pipes',
    years: 25,
  },
  {
    id: 42,
    label: 'Plastics, PVC / PE main pipes',
    years: 50,
  },
  {
    id: 43,
    label: 'Cork linoleum, and underlying layers (subfloor, foils, etc.)',
    years: 30,
  },
  {
    id: 44,
    label: 'Linoleum, and underlying layers (subfloor, foils, etc.)',
    years: 30,
  },
  {
    id: 45,
    label: 'Lead',
    years: 25,
  },
  {
    id: 46,
    label: 'Plaster, indoor',
    years: 15,
  },
  {
    id: 47,
    label: 'Plaster, outdoor',
    years: 25,
  },
  {
    id: 48,
    label: 'Plaster, dried clay',
    years: 50,
  },
  {
    id: 49,
    label: 'Sandwich panel, aluminium (outdoor)',
    years: 40,
  },
  {
    id: 50,
    label: 'Sandwich panel, HPL',
    years: 25,
  },
  {
    id: 51,
    label: 'Sandwich panel, metal indoor',
    years: 75,
  },
  {
    id: 52,
    label: 'Sandwich panel, PVC/polyester',
    years: 30,
  },
  {
    id: 53,
    label: 'Sandwich panel, steel façade/roof',
    years: 50,
  },
  {
    id: 54,
    label: 'Steel, general',
    years: 100,
    yearsBefore: 100,
  },
  {
    id: 55,
    label: 'Steel, installation end pipe',
    years: 25,
  },
  {
    id: 56,
    label: 'Steel, installation main pipe',
    years: 50,
  },
  {
    id: 57,
    label: 'Steel, metal stud wall <0,8mm profile thickness',
    years: 50,
  },
  {
    id: 58,
    label: 'Steel, metal stud wall >=0,8mm profile thickness',
    years: 75,
  },
  {
    id: 59,
    label: 'Steel, sheet galvanised organic coated roof/façade',
    years: 50,
  },
  {
    id: 60,
    label: 'Stone, general',
    years: 100,
    yearsBefore: 500,
  },
  {
    id: 61,
    label: 'Stone, cladding facade',
    years: 75,
  },
  {
    id: 62,
    label: 'Stone, limestone',
    years: 75,
    yearsBefore: 300,
  },
  {
    id: 63,
    label: 'Carpet, and underlying layers (subfloor, foils, etc.)',
    years: 30,
  },
  {
    id: 64,
    label: 'Zink, general',
    years: 40,
  },
  {
    id: 65,
    label: 'Zink, rainwater systems',
    years: 75,
  },
];
